const pageDataNew = {
  menu: [
    { label: '首页', to: '/' },
    // {label: '擎科产品', to: '/products', subMenu: []},
  ],
  products: [
    {
      label: '产品服务', to: '/products/Products1',
      subMenu: [
        {
          label: '基因合成', to: '/products/Products2',
          children: [
            // { label: '基因合成', to: '/tec/gen_compose' },
            { label: '定点突变', to: '/products/Fixed-mutation' },
            { label: 'PCR克隆', to: '/products/PCR_cloning' },
            { label: '质粒抽提', to: '/products/Plasmid_Extraction' },
            { label: '亚克隆', to: '/products/subclone' },
            { label: 'ssDNA', to: '/products/ssDNA_page' },
            { label: 'pETgene', to: '/products/pETgene_page' },
            // { label: 'ETgene', to: '/products/ETgene_page' },
            { label: 'mRNA Poly(A)基因合成', to: '/products/mRNA_Poly_page' },
          ]
        },
        {
          label: '寡核苷酸合成', to: '/tec/compose',
          children: [
            { label: 'DNA合成', to: '/tec/compose1' },
            // 产品要求header中有两个不同链接跳转同一页面，故使用hack方式加上params作为active样式区分
            // { label: '修饰引物/探针合成', to: '/tec/compose2?product=true' },
            { label: 'RNA合成', to: '/tec/compose3?product=true' },
          ],
        },
        {
          label: '寡核苷酸修饰', to: '/equipment/Modified_synthesis',
          children: [
            {
              label: '修饰引物/探针合成', to: '/tec/compose2',
              //children: []
            },
            // {label: 'RNA合成', to: '/tec/compose3'},
          ]
        },
        {
          label: '其他项目服务', to: '/products/Conventional_molecular_project',
          children: [
            { label: 'DNA提取', to: '/tec/DNA_extraction' },
            { label: 'PCR扩增', to: '/tec/PCR' },
            { label: 'SSR、STR检测', to: '/tec/SSR' },
            { label: 'SNP检测', to: '/tec/SNP' },
            { label: '提取+扩增+测序', to: '/products/DNA_tiqu' },
            { label: 'T载体克隆', to: '/products/Tvector_cloning' },
            { label: '特定基因检测', to: '/tec/specific' },
            { label: '荧光定量PCR', to: '/tec/qPCR' },
            { label: '菌种鉴定', to: '/tec/rDNA' },
            { label: '细胞系鉴定', to: '/tec/identification' },
            { label: '甲基化检测(BSP测序)', to: '/products/BSP_Sequencing' },
          ]
        },
        {
          // label: '基因功能',
          label: '基因调控',
          to: '/products/Gene_regulation',
          children: [
            { 
              label: '基因编辑', to: '/products/Gene_editing', 
              children:[
                { label: 'sgRNA合成', to: '/products/sgRNA_Synthesis' },
                { label: 'sgRNA质粒构建', to: '/products/sgRNA_plasmid_construction' },
                { label: 'CRISPRa/CRISPRi应用', to: '/products/CRISPRi_CRISPRa_Applications', },
                { label: 'Cas9 sgRNA文库构建', to: '/products/Cas9_sgRNA_library_construction' },
                { label: 'ssDNA', to: '/ssDNA_page' }
                
              ]
            },
            // { label: 'sgRNA合成', to: '/products/sgRNA_Synthesis' },
            // { label: 'sgRNA质粒构建', to: '/products/sgRNA_plasmid_construction' },
            // {label: 'sgRNA文库构建', to: '/products/sgRNA_library_construction'},
            // { label: 'CRISPRa/CRISPRi应用', to: '/products/CRISPRi_CRISPRa_Applications', },
            // { label: 'Cas9 sgRNA文库构建', to: '/products/Cas9_sgRNA_library_construction' },
            { 
              label: '基因干扰', to: '/products/Gene_interference', 
              children:[
                { label: 'shRNA慢病毒质粒构建', to: '/products/shRNA_lentiviral' },
                { label: 'siRNA/miRNA合成', to: '/products/siRNA_miRNA_synthesis' },
                // { label: '慢病毒包装', to: '/Virus/Lentivirus_packaging' },
                // { label: 'shRNA慢病毒质粒构建', to: '/products/shRNA_lentiviral' },
                // { label: 'ASO/反义寡核苷酸', to: '/products/shRNA_lentiviral' }
              ]
            },
            // { label: 'shRNA慢病毒质粒构建', to: '/products/shRNA_lentiviral' },
            // {label: 'shRNA文库构建', to: '/products/shRNA_library_construction'},
            { label: 'ASO/反义寡核苷酸', to: '/products/ASO_antisense' },
            { label: 'circRNA过表达质粒构建', to: '/products/circRNA_overexpression' },
            // { label: '甲基化检测', to: '/products/Methylation_detection' },
            // { label: '基因Pannel定制及SNP分型', to: '/products/Gene_SNP' },
            // { label: '蛋白表达', to: '/products/Protein_expression' }
            {
              label: '病毒包装', to: '/Virus/Virus_packaging',
              children: [
                { label: '慢病毒包装', to: '/Virus/Lentivirus_packaging' },
                { label: '腺病毒包装', to: '/Virus/Adenovirus_packaging' },
                { label: '腺相关病毒包装', to: '/Virus/Adeno_associated_virus' }]
            },
          ]
        },
        // {
        //   label: '病毒包装', to: '/Virus/Virus_packaging',
        //   children: [
        //     { label: '慢病毒包装', to: '/Virus/Lentivirus_packaging' },
        //     { label: '腺病毒包装', to: '/Virus/Adenovirus_packaging' },
        //     { label: '腺相关病毒', to: '/Virus/Adeno_associated_virus' }]
        // },
        {
          label: '基因检测', to: '/products/Gene',
          children: [
            {
              label: 'Sanger测序', to: '/sanger',
              //children: []
            },
            // {
            //   label: '基因组测序', to: '/products/Genome_sequencing',
            //   children: [
            //     { label: '人全基因组测序', to: '/tec/human_sequencing' },
            //     { label: '人全外显子组测序', to: '/tec/whole_exome' },
            //     { label: '动植物重测序', to: '/tec/Plant_animal_resequencing' },
            //     { label: '线粒体/叶绿体基因组测序', to: '/tec/mitochondrial' },
            //     { label: '病毒基因组测序', to: '/tec/Viral_genome_sequencing' },
            //   ]
            // },
            // {
            //   label: '转录组测序', to: '/products/Transcriptome_sequencing',
            //   children: [
            //     { label: '全转录组测序', to: '/tec/whole_transciptome' },
            //     { label: '原核转录组测序', to: '/tec/prokaryotic' },
            //     { label: '真核转录组测序', to: '/tec/eukaryotic' },
            //     { label: '全长转录组测序', to: '/tec/full_length' },
            //     { label: 'lncRNA测序', to: '/tec/incRNA' },
            //     { label: 'small RNA测序', to: '/tec/smallRNA' }]
            // },
            // {
            //   label: '微生物测序', to: '/products/Microbial_sequencing',
            //   children: [
            //     { label: '16S/18S/ITS扩增子测序（二代）', to: '/tec/ITS' },
            //     { label: '16S/18S/ITS扩增子测序（三代）', to: '/tec/amplicon' },
            //     { label: '细菌基因组测序', to: '/tec/bacterial' },
            //     { label: '真菌基因组测序', to: '/tec/fungal' },
            //     { label: '宏基因组测序', to: '/tec/macrogenome' },]
            // },
            {
              label: 'NGS', noHref: true,
              children: [
                {label: '基因组测序', to: '/products/Genome_sequencing'},
                {label: '转录组测序', to: '/products/Transcriptome_sequencing'},
                {label: '微生物测序', to: '/products/Microbial_sequencing'},
              ]
            },
            {
              label: 'Fast NGS', to: '/tec/1.5_generation_sequencing',
             // children: []
            },

          ]
        },
        {
          label: '快速重组抗体与蛋白表达',
          to: '/products/recombinant-cells-protein-expression', noLeaf: true,
          // children: [
          //   {
          //     label: '快速重组抗体与蛋白表达',
          //     to: '/products/recombinant-cells-protein-expression'
          //   }
          // ]
        },
        {
          label: '化学试剂', to: '/equipment/Chemical_Reagents',
          children: [
            { label: '合成试剂', to:'', ref:'http://www.dnachem.com/?dnasynthesis2/id/20.html' },
            { label: '合成单体', to:'', ref:'http://www.dnachem.com/?dnapcr1/id/16.html' },
            { label: '修饰单体＆CPG', to:'', ref:'http://www.dnachem.com/?dnahc/id/15.html' },
            { label: '合成柱', to:'', ref:'http://www.dnachem.com/?dnahc1/id/8.html' },
            { label: '分子筛', to:'', ref:'http://www.dnachem.com/?dnahc1/id/222.html' }]
        },
        {
          label: '合成设备', to: '/equipment/Instruments_equipment',
          children: [
            {
              label: '合成仪', to: '/intel/device_1',
              // children: [
              //   { label: '合成仪-12通道', to: '/intel/compose12' },
              //   { label: '合成仪-192通道', to: '/intel/compose192' },
              //   { label: '合成仪-768通道', to: '/intel/compose768' }]
            },
            {
              label: '合成配套设备', to: '/intel/device_2',
              children: [
                { label: '氨解仪', to: '/intel/am096' },
                { label: '纯化仪', to: '/intel/AKTA' },
                { label: '溶解仪', to: '/intel/R01' },
                { label: '分装仪', to: '', ref: 'http://www.dnachem.com/?fenzi/id/4.html' },
                { label: '稀释仪', to: '', ref: 'http://www.dnachem.com/?fenzi/id/4.html' },
              ]
            },
            // { label: '小型实验设备', to: '/intel/device_3', children: [] },
          ]
        },
        {
          label: '合成原料/设备/工艺 一站式解决方案', to: '/equipment/IntegratedScheme', noLeaf: true,
        },
      ]
    },
  ],
  molecularReagent: [
    {
      label: '分子试剂',
      to: '/molecular-reagent',
      subMenu: [
        // { label: '核酸提取/纯化', to: '/molecular-reagent?id=1&name=核酸提取%2F纯化' },
        // { label: '反转录系列', to: '/molecular-reagent?id=3&name=反转录系列' },
        // { label: '荧光定量系列', to: '/molecular-reagent?id=30&name=荧光定量系列' },
        // { label: 'PCR系列', to: '/molecular-reagent?id=2&name=PCR系列' },
        // { label: '电泳系列', to: '/molecular-reagent?id=5&name=电泳系列' },
        // { label: '克隆系列', to: '/molecular-reagent?id=4&name=克隆系列' },
        // { label: '感受态系列', to: '/molecular-reagent?id=31&name=感受态系列' },
        // { label: '蛋白系列', to: '/molecular-reagent?id=6&name=蛋白系列' }
      ]
    }
  ],
  lifeSciences:[
    {
      label: '合成设备', to: '/equipment/Instruments_equipment',
      subMenu: [
        {
          label: '合成仪', to: '/intel/device_1',
          // children: [
          //   { label: '合成仪-12通道', to: '/intel/compose12' },
          //   { label: '合成仪-192通道', to: '/intel/compose192' },
          //   { label: '合成仪-768通道', to: '/intel/compose768' }]
        },
        {
          label: '合成配套设备', to: '/intel/device_2',
          children: [
            { label: '氨解仪', to: '/intel/am096' },
            { label: '纯化仪', to: '/intel/AKTA' },
            { label: '溶解仪', to: '/intel/R01' },
            { label: '分装仪', to: '', ref: 'http://www.dnachem.com/?fenzi/id/4.html' },
            { label: '稀释仪', to: '', ref: 'http://www.dnachem.com/?fenzi/id/4.html' },
          ]
        },
        // { label: '小型实验设备', to: '/intel/device_3', children: [] },
      ]
    },
  ],
  equipment: [
    {
      label: '设备原料', to: '/equipment/life_sciences',
      subMenu: [
        { label: '分子检测', to: '/equipment/molecular_detection' },
        { label: '生化诊断', to: '/equipment/biochemical_diagnosis' },
        { label: '仪器设备', to: '', ref:'https://www.masterbio.shop/product/list/6' },
        // {
        //   label: '修饰合成', to: '/equipment/Modified_synthesis',
        //   children: [
        //     {
        //       label: '修饰引物/探针合成', to: '/tec/compose2',
        //       children: []
        //     },
        //     {
        //       label: 'RNA合成', to: '/tec/compose3',
        //       children: []
        //     },
        //   ]
        // },
        // {
        //   label: '仪器设备', to: '/equipment/Instruments_equipment',
        //   children: [
        //     {
        //       label: 'DNA/RNA合成设备', to: '/intel/device_1',
        //       children: [
        //         { label: '合成仪-12通道', to: '/intel/compose12' },
        //         { label: '合成仪-192通道', to: '/intel/compose192' },
        //         { label: '合成仪-768通道', to: '/intel/compose768' }]
        //     },
        //     {
        //       label: '合成配套设备', to: '/intel/device_2',
        //       children: [
        //         { label: '氨解仪', to: '/intel/am096' },
        //         { label: '纯化仪', to: '/intel/AKTA' },
        //         { label: '溶解仪', to: '/intel/R01' },
        //         { label: '分装仪', to: '', ref: 'http://www.dnachem.com/?fenzi/id/4.html' },
        //         { label: '稀释仪', to: '', ref: 'http://www.dnachem.com/?fenzi/id/4.html' },
        //       ]
        //     },
        //     // { label: '小型实验设备', to: '/intel/device_3', children: [] },
        //   ]
        // },
        // {
        //   label: '分子试剂', to: '/equipment/Molecular_reagent',
        //   children: [
        //     { label: '核酸提取/纯化', to: '/equipment/Molecular_reagent?id=1&name=核酸提取%2F纯化' },
        //     { label: '反转录系列', to: '/equipment/Molecular_reagent?id=3&name=反转录系列' },
        //     { label: '荧光定量系列', to: '/equipment/Molecular_reagent?id=30&name=荧光定量系列' },
        //     { label: 'PCR系列', to: '/equipment/Molecular_reagent?id=2&name=PCR系列' },
        //     { label: '电泳系列', to: '/equipment/Molecular_reagent?id=5&name=电泳系列' },
        //     { label: '克隆系列', to: '/equipment/Molecular_reagent?id=4&name=克隆系列' },
        //     { label: '感受态系列', to: '/equipment/Molecular_reagent?id=31&name=感受态系列' },
        //     { label: '蛋白系列', to: '/equipment/Molecular_reagent?id=6&name=蛋白系列' }]
        // },
        // {
        //   label: '化学试剂', to: '/equipment/Chemical_Reagents',
        //   children: [
        //     { label: '合成试剂', ref: 'http://www.dnachem.com/?dnasynthesis2/id/20.html' },
        //     { label: '合成单体', ref: 'http://www.dnachem.com/?dnapcr1/id/16.html' },
        //     { label: '修饰单体＆CPG', ref: 'http://www.dnachem.com/?dnahc/id/15.html' },
        //     { label: '合成柱', ref: 'http://www.dnachem.com/?dnahc1/id/8.html' },
        //     { label: '分子筛', ref: 'http://www.dnachem.com/?dnahc1/id/222.html' }]
        // },
        // {
        //   label: '合成原料/设备/工艺 一站式解决方案', to: '/equipment/IntegratedScheme'
        // }
      ]
    },
  ],
  biology: [
    { label: '生物制造CXO', to: '/Biological_manufacturing/Biological' },
  ],
  geneFactory: [
    { label: '基因工厂', to: '/gene-factory' },
  ],
  resource: [
    { label: '资源中心', to: '/resource', }
  ],
  summary: [
    {
      label: '擎科概况',
      to: '/summary',
      subMenu: [{
        label: '关于擎科',
        children: [
          { label: '擎科简介', to: '/summary/about' },
          // { label: '发展历程', to: '/summary/develop' },
          // { label: '全国布局', to: '/summary/global' },
          { label: '发展成果', to: '/summary/achievement' },
          { label: '联系我们', to: '/summary/contact' },
          { label: '站点地图', to: '/TsingMap', disabled: true }
        ]
      },
      {
        label: '新闻',
        children: [
          { label: '擎科新闻', to: '/news' },
          { label: '市场活动', to: '/news/index1' }
        ]
      },
      {
        label: '加入我们',
        children: [
          { label: '加入擎科', to: '/summary/join_us' }
        ]
      }
      ]
    }
  ],
  TsingMap: [
    { label: '站点地图', to: '/TsingMap', }
  ],
  kbb: [
    { label: '擎科科邦邦商城', ref: process.env.SHOP_URL },
  ],

  footer: [
    {
      title: '合成基因组学产品及服务', children: [
        { name: '基因合成', to: '/tec/compose' },
        { name: '寡核苷酸合成', to: '/tec/compose' },
        { name: '寡核苷酸修饰', to: '/tec/compose' },
        { name: '快速重组抗体与蛋白表达', to: '/tec/compose' },
        { name: '基因调控', to: '/tec/compose' },
        { name: '其他项目服务', to: '/tec/compose' },
        { name: '分子试剂', to: '/tec/compose' },
        { name: '化学试剂', to: '/tec/compose' },
        { name: '合成仪', to: '/tec/compose' },
        { name: '合成配套设备', to: '/tec/compose' },
        { name: '合成原料/设备/工艺一站式解决方案', to: '/tec/compose' },
        { name: '基因检测', to: '/tec/compose' },
        // { name: '引物合成', to: '/tec/compose' },
        // { name: '基因合成', to: '/tec/gen_compose' },
        // { name: '基因检测', to: '/' },
        // { name: '基因功能', to: '/' }
      ]
    },
    {
      title: '生命科学原料及设备', children: [
        { name: '分子检测', to: '/' },
        { name: '生化诊断', to: '/' },
        { name: '仪器设备', to: '/' },
        // { name: '修饰合成', to: '/' },
        // { name: '仪器设备', to: '/' },
        // { name: '化学试剂', to: '/' },
        // { name: '合成仪、合成原料及合成技术整体解决方案', to: '/' },
        // {name: '分子试剂', to: '/'}
      ]
    },
    {
      title: '资源中心', children: [
        { name: '项目服务手册', to: '/resource' },
        { name: '分子试剂手册', to: '/resource' },
        { name: '一代测序登记单', to: '/resource' },
        { name: '在线订购', to: '/' }
      ]
    },
    {
      title: '擎科概况', children: [
        { name: '关于擎科', to: '/summary/about' },
        { name: '新闻资讯', to: '/news?id=1&current=0' },
        { name: '市场活动', to: '/market?id=5' },
        { name: '加入我们', to: '/summary/join_us' }
      ]
    },
  ],
  receiveRules: [
    { value: 'ALL', label: '全部接收（每次出结果都会发送邮件）' },
    { value: 'ONLY_ONE', label: '接收结束邮件（所有结果出完整了，发送一次邮件）' },
    { value: 'TWICE', label: '第一次出结果及最后一次出结果接收邮件（结果出来发送一次，剩下的结果全出了再发送一次）' },
    { value: 'THREE_TIMES', label: '第一次第二次出结果及最后一次出结果接收邮件（结果出了发送前两次，剩下的出全了再发送一次）' },
    { value: 'NON', label: '不发送邮件（不接受邮件，结果自己下载）' }
  ],
  decorateTable: [
    { type: '特殊单体', modify: 'dI', price1: '70' },
    { type: '特殊单体', modify: 'N6-methyl-rA/dA(m6A/m6dA)', price1: '350' },
    { type: '特殊单体', modify: '2\'-O-Methyl C/G/U/A', price1: '70' },
    { type: '特殊单体', modify: '5-Methyl dC/rC(m5C/m5dC)', price1: '70' },
    { type: '特殊单体', modify: 'dU', price1: '70' },
    { type: '特殊单体', modify: '2-F-(C、U)', price1: '200' },
    { type: '特殊单体', modify: '3\'ddC', price1: '300' },
    { type: '特殊单体', modify: 'RNA base', price1: '20' },
    { type: '特殊单体', modify: 'Ferrocene（二茂铁）', price1: '400' },
    { type: '特殊单体', modify: 'Inverted dT', price1: '150' },
    { type: '特殊单体', modify: 'LNA(A T C G)', price1: '250' },
    { type: '非荧光修饰', modify: '5\'Amino Linker C6 ', price1: '160' },
    { type: '非荧光修饰', modify: '3\'Amino Linker C7', price1: '160' },
    { type: '非荧光修饰', modify: 'Amino Linker C6-dT', price1: '160' },
    { type: '非荧光修饰', modify: '5\'Thiol(5\'SH-(CH2)6)', price1: '250' },
    { type: '非荧光修饰', modify: '3\'Thiol(3\'SH-(CH2)6)', price1: '250' },
    { type: '非荧光修饰', modify: '5\'Thiol(C6 S-S)', price1: '250' },
    { type: '非荧光修饰', modify: '3\'Thiol(C6 S-S)', price1: '250' },
    { type: '非荧光修饰', modify: '中间 Thiol(C6 S-S)', price1: '250' },
    { type: '非荧光修饰', modify: '硫代 Phosphorthioate', price1: '5' },
    { type: '非荧光修饰', modify: '5\'Phosphorylation', price1: '150' },
    { type: '非荧光修饰', modify: '3\'Phosphorylation ', price1: '150' },
    { type: '非荧光修饰', modify: '5\'Biotin', price1: '200' },
    { type: '非荧光修饰', modify: '3\'Biotin ', price1: '200' },
    { type: '非荧光修饰', modify: '5\'Biotin teg', price1: '400' },
    { type: '非荧光修饰', modify: '3\'Biotin  teg', price1: '400' },
    { type: '非荧光修饰', modify: 'dT Biotion teg', price1: '400' },
    { type: '非荧光修饰', modify: 'dT Biotion C6', price1: '200' },
    { type: '非荧光修饰', modify: 'Digoxin NHS', price1: '500' },
    { type: '非荧光修饰', modify: 'DBCO NHS', price1: '500' },
    { type: '非荧光修饰', modify: '5\'CHCH', price1: '300' },
    { type: '非荧光修饰', modify: '5\'CHO', price1: '250' },
    { type: '非荧光修饰', modify: '3\'Azide(N3)', price1: '300' },
    { type: '非荧光修饰', modify: '5’ Acrydite', price1: '250' },
    { type: '非荧光修饰', modify: '5\'COOH', price1: '250' },
    { type: '非荧光修饰', modify: '5\'cholesteryl(胆固醇)', price1: '250' },
    { type: '非荧光修饰', modify: '3\'cholesteryl(胆固醇)', price1: '250' },
    { type: '间臂', modify: 'Spacer C3（bp）', price1: '200' },
    { type: '间臂', modify: 'Spacer C6（bp）', price1: '200' },
    { type: '间臂', modify: 'Spacer 9（bp）', price1: '200' },
    { type: '间臂', modify: 'Spacer 12（bp）', price1: '250' },
    { type: '间臂', modify: 'Spacer C12（bp）', price1: '250' },
    { type: '间臂', modify: 'Spacer 18（bp）', price1: '300' },
    { type: '间臂', modify: 'dSpacer(THF)', price1: '300' },
    { type: '中间修饰', modify: 'dT Biotion', price1: '200' },
    { type: '中间修饰', modify: 'HS-SH C6', price1: '250' },
    { type: '中间修饰', modify: 'FAM NHS', price1: '200' },
    { type: '中间修饰', modify: 'ROX NHS', price1: '350' },
    { type: '中间修饰', modify: 'TAMRA NHS', price1: '250' },
    { type: '中间修饰', modify: 'Dabcyl NHS', price1: '300' },
    { type: '中间修饰', modify: 'Digoxin NHS', price1: '500' },
    { type: '中间修饰', modify: 'dT BHQ1', price1: '350' },
    { type: '中间修饰', modify: 'Quasar670', price1: '600' },
    { type: '中间修饰', modify: 'Cy3', price1: '600' },
    { type: '中间修饰', modify: 'Amino Linker C6-dT', price1: '250' },
    { type: '中间修饰', modify: 'Alexa flour 594(NHS)', price1: '450' },
    { type: '中间修饰', modify: 'Alexa flour 633(NHS)', price1: '350' },
    { type: '荧光基团', modify: '5\'FAM', price1: '200' },
    { type: '荧光基团', modify: '3\'FAM', price1: '200' },
    { type: '荧光基团', modify: '5\'HEX', price1: '250' },
    { type: '荧光基团', modify: '3\'HEX', price1: '300' },
    { type: '荧光基团', modify: '5\'TET', price1: '300' },
    { type: '荧光基团', modify: '5\'TAMRA', price1: '250' },
    { type: '荧光基团', modify: '3\'TAMRA', price1: '300' },
    { type: '荧光基团', modify: '5\'ROX', price1: '350' },
    { type: '荧光基团', modify: '3\'ROX', price1: '350' },
    { type: '荧光基团', modify: '5\'Cy3', price1: '600' },
    { type: '荧光基团', modify: '3\'Cy3', price1: '600' },
    { type: '荧光基团', modify: '5\'Cy5', price1: '600' },
    { type: '荧光基团', modify: '3\'Cy5', price1: '800' },
    { type: '荧光基团', modify: '5\'VIC', price1: '800' },
    { type: '荧光基团', modify: '5\'Joe', price1: '600' },
    { type: '荧光基团', modify: '5\'Quasar 570', price1: '600' },
    { type: '荧光基团', modify: '5\'Quasar 670', price1: '600' },
    { type: '荧光基团', modify: 'Alexa flour 594(NHS)', price1: '450' },
    { type: '荧光基团', modify: 'Alexa flour 633(NHS)', price1: '350' },
    { type: '荧光基团', modify: '3\'Cy3.5', price1: '1000' },
    { type: '荧光基团', modify: '5\'Cy3.5', price1: '1000' },
    { type: '荧光基团', modify: '中间Cy3.5', price1: '1000' },
    { type: '荧光基团', modify: '3\'Cy5.5', price1: '1000' },
    { type: '荧光基团', modify: '5’Cy5.5', price1: '1000' },
    { type: '荧光基团', modify: '中间Cy5.5', price1: '1000' },
    { type: '荧光基团', modify: '3\'Cy7', price1: '1000' },
    { type: '荧光基团', modify: '5\'Cy7', price1: '1000' },
    { type: '荧光基团', modify: '中间Cy7', price1: '1000' },
    { type: '淬灭基团', modify: '3\'Dabcyl', price1: '300' },
    { type: '淬灭基团', modify: '5\'Dabcyl', price1: '350' },
    { type: '淬灭基团', modify: 'TAMRA NHS', price1: '250' },
    { type: '淬灭基团', modify: '3\'BHQ1', price1: '350' },
    { type: '淬灭基团', modify: '5\'BHQ1', price1: '350' },
    { type: '淬灭基团', modify: 'dT BHQ1', price1: '350' },
    { type: '淬灭基团', modify: '3\'BHQ2', price1: '500' },
    { type: '淬灭基团', modify: '3\'BHQ3', price1: '350' },
    { type: '淬灭基团', modify: '3\'Eclipse', price1: '350' },
    { type: '淬灭基团', modify: '3\'MGB', price1: '900' },
    { type: '双标', modify: '5\'FAM and 3\'TAMRA', price1: '800' },
    { type: '双标', modify: '5\'FAM and 3\'BHQ1', price1: '800' },
    { type: '双标', modify: '5\'FAM and 3\'dT BHQ1', price1: '800' },
    { type: '双标', modify: '5\'FAM and 3\'Dabcyl', price1: '800' },
    { type: '双标', modify: '5\'FAM and 3\'Eclipse', price1: '1000' },
    { type: '双标', modify: '5\'FAM and 3\'MGB', price1: '1200' },
    { type: '双标', modify: '5\'Phos and 3\'FAM', price1: '500' },
    { type: '双标', modify: '5\'HEX and 3\'BHQ1', price1: '1000' },
    { type: '双标', modify: '5\'HEX and 3\'Eclipse', price1: '1000' },
    { type: '双标', modify: '5\'HEX and dT BHQ1', price1: '1000' },
    { type: '双标', modify: '5\'HEX and 3\'TAMRA', price1: '800' },
    { type: '双标', modify: '5\'HEX and 3\'MGB', price1: '1500' },
    { type: '双标', modify: '5\'TAMRA and 3\'Phos', price1: '550' },
    { type: '双标', modify: '5\'TAMRA and 3 \'Eclipse', price1: '1200' },
    { type: '双标', modify: '5\'TAMRA and 3\'Dabcyl', price1: '1200' },
    { type: '双标', modify: '5\'TAMRA and 3\'BHQ2', price1: '1000' },
    { type: '双标', modify: '5\'ROX and 3\'BHQ2', price1: '800' },
    { type: '双标', modify: '5\'ROX and 3\'Eclipse', price1: '800' },
    { type: '双标', modify: '5\'ROX and 3\'MGB', price1: '1500' },
    { type: '双标', modify: '5\'TET and 3\'BHQ-1', price1: '1000' },
    { type: '双标', modify: '5\'TET and 3\'Dabcyl', price1: '1000' },
    { type: '双标', modify: '5\'TET and 3\'Eclipse', price1: '1000' },
    { type: '双标', modify: '5\'TET and 3\'TAMRA', price1: '1200' },
    { type: '双标', modify: '5\'Joe and 3\'TAMRA', price1: '1000' },
    { type: '双标', modify: '5\'Joe and 3\'Dabcyl', price1: '1000' },
    { type: '双标', modify: '5\'Joe and 3\'Eclipse', price1: '1000' },
    { type: '双标', modify: '5\'Joe and 3\'BHQ1', price1: '1200' },
    { type: '双标', modify: '5\'VIC and 3\'Dabcyl', price1: '1000' },
    { type: '双标', modify: '5\'VIC and 3\'BHQ1', price1: '1000' },
    { type: '双标', modify: '5\'VIC and 3\'TAMRA', price1: '1000' },
    { type: '双标', modify: '5\'VIC and 3\'MGB', price1: '1200' },
    { type: '双标', modify: '5\'Quasar 570 and 3\'BHQ2', price1: '1000' },
    { type: '双标', modify: '5\'Quasar 670 and 3\'BHQ3', price1: '1000' },
    { type: '双标', modify: '5\'Cy3 and 3\'BHQ2', price1: '1000' },
    { type: '双标', modify: '5\'Cy5 and 3\'BHQ3', price1: '1000' },
    { type: '双标', modify: '5\'Cy3 and 3\'BHQ2', price1: '1000' }
  ],
  RNAtable1: [{
    product: '普通化学合成siRNA',
    scale: '5 nmol',
    price: '￥ 300'
  }, {
    product: '普通化学合成siRNA',
    scale: '10 nmol',
    price: '￥ 500'
  }, {
    product: '固醇修饰化学合成siRNA',
    scale: '5 nmol',
    price: '￥ 700'
  }, {
    product: '固醇修饰化学合成siRNA',
    scale: '10 nmol',
    price: '￥ 1100'
  }],
  RNAtable2: [{
    product: '单基因套装 siRNA 设计与合成（四保一）',
    intro: '针对目的基因设计并合成四对各5nmol的siRNA',
    scale: '5 nmol*4',
    price: '￥ 1500.00'
  }, {
    product: '单基因套装 siRNA 设计与合成（四保一）',
    intro: '阴性对照的siRNA',
    scale: '2.5 nmol',
    price: '￥ 1500.00'
  }, {
    product: '单基因套装 siRNA 设计与合成（四保一）',
    intro: '阳性对照的siRNA',
    scale: '2.5 nmol',
    price: '￥ 1500.00'
  }, {
    product: '单基因套装 siRNA 设计与合成（四保一）',
    intro: 'Fam标记阴性对照siRNA（转染后12小时观察转染效果）',
    scale: '1 nmol',
    price: '￥ 1500.00'
  }, {
    product: '单基因套装 siRNA 设计与合成（三保一）',
    intro: '针对目的基因设计并合成三对各5nmol的siRNA',
    scale: '5 nmol*4',
    price: '￥ 1250.00'
  }, {
    product: '单基因套装 siRNA 设计与合成（三保一）',
    intro: '针对目的基因设计并合成四对各5nmol的siRNA',
    scale: '5 nmol*4',
    price: '￥ 1250.00'
  }, {
    product: '单基因套装 siRNA 设计与合成（三保一）',
    intro: '针对目的基因设计并合成四对各5nmol的siRNA',
    scale: '5 nmol*4',
    price: '￥ 1250.00'
  }, {
    product: '单基因套装 siRNA 设计与合成（三保一）',
    intro: '针对目的基因设计并合成四对各5nmol的siRNA',
    scale: '5 nmol*4',
    price: '￥ 1250.00'
  }, {
    product: '胆固醇单基因 siRNA 设计与合成',
    intro: '针对目的基因设计并合成三对各5nmol胆固醇修饰的siRNA',
    scale: '5 nmol*3',
    price: '￥ 2998.00'
  }, {
    product: '胆固醇单基因 siRNA 设计与合成',
    intro: '胆固醇修饰阴性对照的siRNA',
    scale: '2.5 nmol',
    price: '￥ 2998.00'
  }, {
    product: '胆固醇单基因 siRNA 设计与合成',
    intro: '胆固醇修饰阳性对照的siRNA',
    scale: '2.5 nmol',
    price: '￥ 2998.00'
  }],
  RNAtable3: [{
    product: 'miRNA mimics',
    scale: '5 nm',
    price: '¥ 350.00'
  }, {
    product: 'miRNA inhibitor',
    scale: '5 nm',
    price: '¥ 350.00'
  }],
  RNAtable4: [{
    product: '背靠背引物设计验证',
    type: 'divergent引物设计验证（circRNA，含qPCR产物测序）'
  }, {
    product: '背靠背引物设计验证',
    type: 'convergent引物设计验证'
  }, {
    product: '背靠背引物设计验证',
    type: 'RNaseR使用费'
  }, {
    product: '背靠背引物设计验证',
    type: 'RNA抽提 + RNaseR处理 + 逆转录'
  }, {
    product: '背靠背引物设计验证',
    type: 'DNA抽提'
  }, {
    product: '背靠背引物设计验证',
    type: 'cDNA + gDNA普通PCR'
  }, {
    product: '背靠背引物设计验证',
    type: '产物凝胶电泳'
  }],
  contact: [{
    name: '北京擎科(总部)',
    address: '地 址：北京市北京经济技术开发区经海三路105号院3号楼西半单元',
    zipCode: '邮 编：102209',
    tel: '电 话：400-668-3730',
    email: '邮箱：bj-seq@tsingke.com.cn (测序) bj-synth@tsingke.com.cn (合成)'
  }, {
    name: '长沙擎科',
    address: '地 址：湖南省长沙市岳麓区银盆南路315号湘能大厦中栋6楼',
    zipCode: '邮 编：410000',
    tel: '电 话：400-668-3730',
    email: '邮箱：cs-seq@tsingke.com.cn(测序) cs-synth@tsingke.com.cn (合成)'
  }, {
    name: '广州擎科',
    address: '地 址：广州市黄埔区开源大道188号广州莱迪创新科技园14-1栋6层',
    zipCode: '邮 编：510000',
    tel: '电 话：400-668-3730',
    email: '邮箱：gz-seq@tsingke.com.cn (测序) gz-synth@tsingke.com.cn (合成)'
  }, {
    name: '上海擎科',
    address: '地 址：上海市闵行区浦江镇江月路999号19号楼4楼',
    zipCode: '邮 编：201114',
    tel: '电 话：400-668-3730',
    email: '邮箱：sh-seq@tsingke.com.cn（测序） sh-synth@tsingke.com.cn（合成）'
  }, {
    name: '重庆擎科',
    address: '地 址：重庆市沙坪坝区西园北街14号生产力服务大厦第3层',
    zipCode: '邮 编：401332',
    tel: '电 话：400-668-3730',
    email: '邮箱：cq-seq@tsingke.com.cn (测序) cq-synth@tsingke.com.cn (合成)'
  }, {
    name: '武汉擎科',
    address: '地 址：武汉市东湖新技术开发区高科园三路9号武汉精准医疗产业基地6栋3层302室、6栋4层402室',
    zipCode: '邮 编：430040',
    tel: '电 话：400-668-3730',
    email: '邮箱：wh-seq@tsingke.com.cn (测序) wh-synth@tsingke.com.cn (合成)'
  }, {
    name: '郑州擎科',
    address: '地 址：河南省郑州市高新区长椿路十一号国家大学科技园7号厂房E座5楼',
    zipCode: '邮 编：450000',
    tel: '电 话：400-668-3730',
    email: '邮箱：zz-seq@tsingke.com.cn (测序) zz-synth@tsingke.com.cn (合成)'
  }, {
    name: '成都擎科',
    address: '地 址：成都市高新区科园南路5号蓉药大厦A栋5楼',
    zipCode: '邮 编：610102',
    tel: '电 话：400-668-3730',
    email: '邮 箱：cd-seq@tsingke.com.cn (测序) cd-synth@tsingke.com.cn (合成)'
  }, {
    name: '天津擎科',
    address: '地 址：天津市武清开发区新创路6号健康产业园3号厂房一层西侧',
    zipCode: '邮 编：301700',
    tel: '电 话：400-668-3730',
    email: '邮箱：bj-seq@tsingke.com.cn (测序) bj-synth@tsingke.com.cn (合成)'
  }, {
    name: '杭州擎科',
    address: '地 址：杭州市西湖区西园三路3号杭州智能创新产业园B栋702',
    zipCode: '邮 编：310030',
    tel: '电 话：400-668-3730',
    email: '邮箱：hz-seq@tsingke.com.cn (测序) hz-synth@tsingke.com.cn (合成)'
  }, {
    name: '哈尔滨擎科',
    address: '地 址：哈尔滨开发区哈平路集中区渤海路6号',
    zipCode: '邮 编：150069',
    tel: '电 话：400-668-3730',
    email: '邮箱：hrb-seq@tsingke.com.cn(测序) hrb-synth@tsingke.com.cn(合成)'
  }, {
    name: '昆明擎科',
    address: '地 址：昆明市盘龙区都市产业园',
    zipCode: '邮 编：650000',
    tel: '电 话：400-668-3730',
    email: '邮箱：km-seq@tsingke.com.cn(测序) km-synth@tsingke.com.cn(合成)'
  }, {
    name: '青岛擎科',
    address: '地 址：山东省青岛市高新区松园路17号工业技术研究院B1楼',
    zipCode: '邮 编：266000',
    tel: '电 话：400-668-3730',
    email: '邮箱：qd-seq@tsingke.com.cn (测序) qd-synth@tsingke.com.cn (合成)'
  }, {
    name: '南京擎科',
    address: '地 址：南京市江宁区高新园乾德路9号2号楼5楼',
    zipCode: '邮 编：210000',
    tel: '电 话：400-668-3730',
    email: '邮箱：nj-seq@tsingke.com.cn (测序) nj-synth@tsingke.com.cn (合成)'
  }, {
    name: '西安擎科',
    address: '地 址：西安市未央区尚稷路8989号西安服务外包产业园C座5层',
    zipCode: '邮 编：710018',
    tel: '电 话：400-668-3730',
    email: '邮箱：xa-seq@tsingke.com.cn (测序) xa-synth@tsingke.com.cn (合成)'
  }, {
    name: '南宁擎科',
    address: '地 址：广西省南宁市西乡塘区正鑫科技园实验楼701',
    zipCode: '邮 编：530007',
    tel: '',
    email: '邮箱：nn-synth@tsingke.com.cn(合成)'
  }, {
    name: '厦门擎科',
    address: '地 址：厦门市翔安区翔安南路5002号402室',
    zipCode: '邮 编：361000',
    tel: '',
    email: '邮箱：xm-synth@tsingke.com.cn(合成)'
  }, {
    name: '海口擎科',
    address: '地 址：海口市秀英区海榆中线199号金鹿工业区C10栋',
    zipCode: '邮 编：570010',
    tel: '',
    email: '邮箱： hk-synth@tsingke.com.cn(合成)'
  }, {
    name: '全国产品事业部',
    address: '地 址：北京市海淀区清华东路16号艺海大厦706',
    zipCode: '邮 编：102209',
    tel: '电 话：400-668-3730',
    email: '邮箱：product@tsingke.com.cn'
  }],
  extractionTable: [{
    name: 'SH-1',
    k41: 'AA',
    k42: 'GC',
    k43: 'GG',
    k44: 'TG',
    k45: 'AG',
    k71: 'GG',
    k72: 'CC',
    k73: 'AA',
    k74: 'AA',
    k75: 'GG'
  }, {
    name: 'SH-2',
    k41: 'AA',
    k42: 'GC',
    k43: 'GT',
    k44: 'AG',
    k45: 'GG',
    k71: 'GG',
    k72: 'CC',
    k73: 'AA',
    k74: 'AA',
    k75: 'GG'
  }, {
    name: 'SH-3',
    k41: 'GA',
    k42: 'GC',
    k43: 'GT',
    k44: 'TA',
    k45: 'GG',
    k71: 'GG',
    k72: 'CC',
    k73: 'GA',
    k74: 'AA',
    k75: 'GG'
  }, {
    name: 'SH-4',
    k41: 'GG',
    k42: 'GC',
    k43: 'GG',
    k44: 'TG',
    k45: 'GG',
    k71: 'GG',
    k72: 'CC',
    k73: 'GG',
    k74: 'AA',
    k75: 'GG'
  }, {
    name: 'SH-5',
    k41: 'GA',
    k42: 'GC',
    k43: 'GG',
    k44: 'GG',
    k45: 'GG',
    k71: 'GG',
    k72: 'CC',
    k73: 'GA',
    k74: 'AA',
    k75: 'GG'
  }, {
    name: 'SH-6',
    k41: 'GA',
    k42: 'CC',
    k43: 'GG',
    k44: 'TG',
    k45: 'GG',
    k71: 'GG',
    k72: 'CC',
    k73: 'GA',
    k74: 'AA',
    k75: 'GG'
  }, {
    name: 'SH-7',
    k41: 'GG',
    k42: 'CC',
    k43: 'GG',
    k44: 'TG',
    k45: 'GG',
    k71: 'GG',
    k72: 'CC',
    k73: 'GG',
    k74: 'AA',
    k75: 'GG'
  }, {
    name: 'SH-8',
    k41: 'AA',
    k42: 'GC',
    k43: 'GT',
    k44: 'AG',
    k45: 'GG',
    k71: 'GG',
    k72: 'CC',
    k73: 'AA',
    k74: 'AA',
    k75: 'GG'
  }, {
    name: 'SH-9',
    k41: 'AA',
    k42: 'CC',
    k43: 'GG',
    k44: 'TT',
    k45: 'AA',
    k71: 'GG',
    k72: 'CC',
    k73: 'AA',
    k74: 'AA',
    k75: 'GG'
  }],
  qualities: ['4ug', '100ug', '200ug', '500ug', '1mg', '2mg', '3mg', '4mg', '5mg', '10mg', '20mg']
}
export default pageDataNew



// WEBPACK FOOTER //
// ./src/utils/pageDataNew.js